// react
import React, { useEffect } from 'react';
import L from "leaflet"
import "leaflet-draw";
import "leaflet-editable"
import "leaflet.path.drag"
import { EXTENDBOUNDS, MAP_URLS } from '../../AppConstants';

// leaflet

function SingleMap(props) {
  useEffect(() => {
    var map = L.map(props.id || 'map', {
      maxZoom: props.maxZoom ? props.maxZoom : 28,
      editable: true,
      center: props.initCenter,
      zoomControl: false,
      zoom: 16,
      attributionControl: false,
      scrollWheelZoom: !props.disableZoom,   // Disables zoom with scroll wheel
      doubleClickZoom: !props.disableZoom,  // Disables zoom with double click
      dragging: !props.disableDragging
    })
    map.createPane("tooltips")
    map.getPane('tooltips').style.zIndex = 10000
    props.setMap(map)
    console.log(props.initCenter)



    if (props.bounds) {
      let bounds = [[props.bounds[1] - EXTENDBOUNDS, props.bounds[0] - EXTENDBOUNDS], [props.bounds[3] + EXTENDBOUNDS, props.bounds[2] + EXTENDBOUNDS]]
      map.fitBounds(bounds);
    }
    else {
      if (props.annotations && props.annotations.length > 0) {
        props.annotations.map(a => {
          a.addTo(map)
        })
        let bounds = props.annotations[0].getBounds()
        map.fitBounds(bounds)
      } else {
        map.fitBounds([[26.798175480657605, 82.7132375946003], [26.82286941676843, 82.75360145561896]]);
      }
    }
    let baseLayer = L.tileLayer(props.initBaseLayerURL || MAP_URLS.SATELITE, {
      attribution: 'Imagery ©2022 CNES / Airbus, Landsat / Copernicus, Maxar Technologies, Map data ©2022',
      maxZoom: props.maxZoom,
      center: props.initCenter,
      zoom: 18,
      tileSize: 256,
    }).addTo(map);
    if (props.isTaskTraining) {

      var CartoDB_DarkMatter = L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20,
        opacity: 0.7
      }).addTo(map);
    }
    if (props.setBaseLayerToState) props.setBaseLayerToState(baseLayer);
    if (props.handleMapClick) map.on('click', props.handleMapClick);
    if (props.handleMoveStart) map.on('movestart', props.handleMoveStart);
  }, [])


  // render component
  return (
    <>
      {props.children}
      <div style={props.style}
        id={props.id ? props.id : "map"}>
        {props.innerMapChildren ? props.innerMapChildren : <></>}
      </div>
    </>
  )

}

export default SingleMap
